module.exports = __webpack_public_path__ + "static/img/icon_94_chentieno.c331dffa.png";